import { Coord, SliderColorStyle } from "../../../types/Interface";

export function getSliderCoords(dim: { WIDTH: number, HEIGHT: number }, SLIDERS_COORD:Coord[], SLIDERS_COORD_OFFSET_VERTICAL:Coord[]) {
  return dim.WIDTH > dim.HEIGHT ? SLIDERS_COORD : SLIDERS_COORD_OFFSET_VERTICAL.map(o => ({ x: dim.WIDTH / 2 + o.x, y: dim.HEIGHT / 2 + o.y }));
}

export function generateSliderProps(coord: Coord, head: string, colors: SliderColorStyle, subHead: string = "", keepCurrSlider: boolean = false) {
  return {
    x: coord.x,
    y: coord.y,
    head,
    subHead,
    keepCurrSlider,
    sliderStyle: colors
  }
}